import { createBlock } from 'factories/block';
import { InteractionProps } from './interaction';
import { createLayout } from 'factories/layout';
import { createMediaBlock } from './media';
import { createContinueBtn } from './continueBtn';
import { getSId } from '../utils';
import { getPlaceholderText } from './text';

export type ImageInteractionProps = InteractionProps & {};

const contentForColumn = props => (i: number) => {
  // need to know which media we're creating
  // text 0
  // image 1
  // . . .

  let textPlaceholderContent = '';
  let className = '';

  if ([0, 1, 3, 5, 6].includes(props?.child)) {
    textPlaceholderContent = getPlaceholderText('h2', 'heading-two');
  }

  if ([2, 4].includes(props?.child)) {
    textPlaceholderContent = getPlaceholderText('h1', 'heading-one');
    className = 'text-align-center';
  }

  return [
    () =>
      createMediaBlock({
        child: 0,
        textPlaceholderContent,
        className,
      }),
    () =>
      createBlock('InteractionColumn', [
        createMediaBlock(props),
        createMediaBlock({
          child: 0,
          isAdditionalMedia: true,
        }),
      ]),
  ][i];
};

export const createImageInteractionBlock = (props: any) => {
  // will fix this up later with the ' prop 'er definitions etc

  const { lockDown = 0, style } = props as any;

  const forceOneColumnReversed = [2, 4].includes(props.child);

  return createBlock(
    'Interaction',
    [
      createLayout(
        contentForColumn(props),
        forceOneColumnReversed ? 0 : props.columnCount,
        forceOneColumnReversed ? true : props.columnsReversed
      ),
      createBlock('SingleColumnLayout', [
        createBlock('Column', [createContinueBtn(style)], {
          props: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
          },
          meta: {
            subType: 'ButtonBlock',
          },
        }),
      ]),
    ],
    {
      props: {
        name: props.name,
        sId: getSId('interaction'),
        style: props.style,
        lockDown,
      },
      meta: {
        subType: 'TextAndImage',
        layout: forceOneColumnReversed
          ? 'OneColumnReversed'
          : `${props.columnCount === 0 ? 'OneColumn' : 'TwoColumns'}${
              props.columnsReversed ? 'Reversed' : ''
            }`,
      },
    }
  );
};

export const interactionConfig = {};
